import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { StudyType } from '../../../../models/study-type';
import { Store } from '@ngrx/store';
import { AppState } from '../../../../state';
import { openCreateStudyPageWithDetails, selectStudy } from '../../../state/study/study.actions';

@Component({
  selector: 'dashboard-create-study-dialog',
  templateUrl: './create-study-dialog.component.html',
  styleUrls: ['./create-study-dialog.component.scss'],
})
export class CreateStudyDialogComponent implements OnInit {
  StudyType = StudyType;
  userStudyTypes: string[] = [];
  selectedStudyType: string;

  constructor(
    private store: Store<AppState>,
    private createStudyDialogRef: MatDialogRef<CreateStudyDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { userStudyTypes: string[] }
  ) {}

  /** Default selected type should be one of two - TIIM or CC.
   * To maintain that exact order, we check userStudyTypes array in both html and ts.
   */

  ngOnInit(): void {
    if (this.data && this.data.userStudyTypes) {
      this.userStudyTypes = this.data.userStudyTypes;

      if (this.userStudyTypes.includes(StudyType.TIIM)) {
        this.selectedStudyType = StudyType.TIIM;
      } else {
        this.selectedStudyType = StudyType.CC;
      }
    }
  }

  selectStudyType(studyType: string): void {
    this.selectedStudyType = studyType;
  }

  createStudy(): void {
    this.store.dispatch(openCreateStudyPageWithDetails({ studyType: this.selectedStudyType }));
    this.createStudyDialogRef.close();
  }
}
